var _defineMessages;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { defineMessages } from 'react-intl';
import { VERTICALS } from '../Search.constants';
export var messages = defineMessages((_defineMessages = {}, _defineProperty(_defineMessages, VERTICALS.all, {
  id: 'search.search-box.message.all',
  defaultMessage: 'All'
}), _defineProperty(_defineMessages, VERTICALS.gym, {
  id: 'search.search-box.message.gym',
  defaultMessage: 'All gyms'
}), _defineProperty(_defineMessages, VERTICALS.fitness, {
  id: 'search.search-box.message.fitness',
  defaultMessage: 'All fitness'
}), _defineProperty(_defineMessages, VERTICALS.wellness, {
  id: 'search.search-box.message.wellness',
  defaultMessage: 'All wellness'
}), _defineMessages));